import client from './client'

export default {
    getNumberOfItems: () => {
        return new Promise((resolve, reject) => {
        client.get('https://www.hideki.co.jp/api/saying/')
            .then(res => resolve({ count: res.data.count}))
            .catch(err => {
            reject(new Error(err.response.data.message || err.message))
            })
        })
    },
    getAllList: (num) => {
        return new Promise((resolve, reject) => {
        client.get('https://www.hideki.co.jp/api/saying/', { params: { page_size: num } })
            .then(res => resolve({ results: res.data.results }))
            .catch(err => {
            reject(new Error(err.response.data.message || err.message))
            })
        })
    },
 }
